import React, { useState, useRef, useEffect } from "react";
import AllTimeline from "./allTimeline";
import { GetNews } from "../../apis/api/NewsApi";
import { useDispatch,useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Lodderr from "../../components/Lodder/Lodder";
import { formatDMY } from "../../utils/date";
const Timeline = () => {

  const dispatch= useDispatch();
  const navigate=useNavigate()
  useEffect(()=>{
   dispatch(GetNews());
  },[])
 
   const {news} = useSelector((state) => state.NewsSlice);
 const {loading} = useSelector((state) => state.NewsSlice);

 
   const handleRedirect = (news) => {
    navigate("/newsArticle", { state: { newsData: news } });
  };

  return (
    <>

     {loading && <Lodderr/>} 
      <div class="row d-flex justify-content-between">
        <div className="col-md-7 col-lg-8 col-sm-12 fixed-column">
          <AllTimeline/>
        </div>

        <div className="col-md-4 col-lg-3 col-sm-12 fixed-column">
          <div className="headline-card">
            <div className="headline-card-header">
              <i className="bx bx-news"></i>
              <h5>Latest News</h5>
            </div>
          </div>


          <div className="news-cards">
            {news.map((news) => (
               <div className="card news-card shadow-sm">
               <div className="news-image-wrapper">
                 <img src={news.image ? news.image?.replace("/thumb", "") : 'assets/images/dummy-news-img.jpeg'} className="card-img-top" alt={news.title} />
               </div>
               <div className="card-body">
                 <h5 className="card-title text-truncate text-limit">{news.title}</h5>
                 <p className="text-muted small">
                   <i className="bx bx-calendar"></i> {formatDMY(news.date)}
                 </p>
                 <p className="card-text description text-limit">{news.description?.replace(/<\/?[^>]+(>|$)/g, "").slice(0, 150)}
                 </p>
                 <div className=" d-flex justify-content-center">
                 <button className="btn btn-dark btn-sm "onClick={() => handleRedirect(news)}>
                   <i className="bx bx-news"></i> Read More
                 </button>
     
                 </div>
               </div>
             </div>
            ))}
          </div>
        </div>

      </div>


    </>
  );
};

export default Timeline;
